import React from "react";
import { Link } from "react-router-dom";
import { Card, CardActionArea, CardContent, CardMedia, makeStyles, Grid, Theme, Typography } from "@material-ui/core";
import { MarketingPageType } from "../types/MarketingPageType";
import replaceAllCompat from "../../../utilities/replaceAllCompat";

const useStyles = makeStyles((theme: Theme) => ({
	media: {
		paddingTop: "56.25%", // 16:9 ratio
		width: "100%",
		height: "100%",
		objectFit: "cover",
	},
	maximumWidth: {
		minWidth: "100%",
	},
	maximumWidthMobile: {
		[theme.breakpoints.down("xs")]: {
			minWidth: "100%",
		},
	},
	noUnderline: {
		textDecoration: "none",
	},
}));

interface Props {
	assetName: string;
	assetType: MarketingPageType;
	cardImage: string;
	cardTitle: string;
	cardContent: string;
}

export function SermonCard({ cardImage, cardTitle, cardContent, assetName, assetType }: Props) {
	const classes = useStyles();
	const getUrlSafeAssetName = (assetName: string) => {
		let safeToEncodeAssetName = replaceAllCompat(replaceAllCompat(assetName, "-", "_"), "%", "&per&");
		let encodedAssetName = encodeURIComponent(safeToEncodeAssetName);
		encodedAssetName = replaceAllCompat(encodedAssetName, "%20", "-");
		encodedAssetName = replaceAllCompat(encodedAssetName, "?", "%3F");
		return encodedAssetName;
	};

	let urlSafeAssetName = getUrlSafeAssetName(assetName);
	const cardLink = `/popular-${assetType === MarketingPageType.Series ? "sermon-series" : "sermons"}/${urlSafeAssetName}`;

	return (
		<Grid item lg={3} md={4} sm={6} className={classes.maximumWidthMobile}>
			<Link to={cardLink} className={classes.noUnderline}>
				<Card style={{height: "100%"}}>
					<CardActionArea className={classes.maximumWidth}>
						<CardMedia className={classes.media} image={cardImage} title={cardTitle} />
						<CardContent>
							<Typography gutterBottom variant="h5" component="h2">
								{cardTitle}
							</Typography>
							<Typography variant="body2" color="textSecondary" component="p">
								{cardContent}
							</Typography>
						</CardContent>
					</CardActionArea>
				</Card>
			</Link>
		</Grid>
	);
}